<template>
    <div class="lms__superadmin_customer_service_show">
        <div class="lms__superadmin_customer_service_show_header">
            <view-actions
                :title="`${customerName}: ${serviceKey} ${this.$t('lms.customer.title.subscriptions')}`"
                :notify-title="'service'"
                :notify-process="$t('lms.customer.viwAction.notifyStopManaging')"
                :cancel-notify-active="false"
                :cancel-button-text="$t('lms.customer.viwAction.buttonStopManaging')"
                :submit-button-active="false"
                :breadcrumb-active="true"
                :breadcrumb-items="[
                    {
                        name: customerName,
                        to: customerTo
                    }
                ]"
                @emit-cancel="subscriptionStopEdit"
            />
        </div>
        <div class="lms__superadmin_customer_service_show_main">
            <div class="container">
                <div class="lms__superadmin_customer_service_show_main_actions">
                    <div class="columns is-vcentered">
                        <template v-if="serviceKey === 'API' && customerHasServices.API">
                            <div class="column is-narrow">
                                <component-note>API is active, would you like to activate it for a workspace?
                                    <component-button
                                        :name="'lms-superadmin-customer-service-show-workspaces-link'"
                                        :text="true"
                                        :to="{ name: 'lms-superadmin-customer-edit-workspaces', params: { id: customerId } }"
                                    >View workspaces
                                    </component-button>
                                </component-note>
                            </div>
                        </template>
                        <div class="column">
                            <base-filter
                                :search-active="false"
                                :list-active="false"
                                :actions-active="true"
                                :actions-secondary-button-active="false"
                                :actions-primary-button-text="serviceKey === 'SSO' ? 'Add SSO' : 'Add subscription'"
                                :note-active="customerServiceSSO && serviceKey === 'SSO'"
                                :note-text="'Go to workspace settings to activate SSO per workspace'"
                                :overlay="false"
                                @emit-actions-primary="handleAddSubscription"
                            />
                        </div>
                    </div>
                </div>
                <div class="lms__superadmin_customer_service_show_main_table">
                    <div class="columns custom--overflow">
                        <div class="column">
                            <lms-superadmin-customer-service-show-table
                                ref="servicetable"
                                :subscriptions="subscriptions"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import ViewActions from '@/components/default/shared/ViewActions'
import LmsSuperadminCustomerServiceShowTable
  from '@/components/lms/superadmin/customer/service/show/LmsSuperadminCustomerServiceShowTable'
import BaseFilter from '@/components/default/filters/BaseFilter'
import ComponentNote from '@/components/default/shared/ComponentNote'
import ComponentButton from '@/components/default/shared/ComponentButton'
import { User } from '@/User'

export default {
  name: 'lms-superadmin-customer-service-show',
  components: { ComponentButton, ComponentNote, BaseFilter, LmsSuperadminCustomerServiceShowTable, ViewActions },
  data () {
    return {
      user: new User()
    }
  },
  computed: {
    serviceKey () {
      return this.$route.params.serviceKey
    },
    subscriptions () {
      return this.$store.getters.getLmsSuperadminCustomerSubscriptionsByKey(this.serviceKey)
    },
    customerName () {
      return this.$store.getters.getLmsSuperadminCustomerName
    },
    customerServiceSSO () {
      return this.$store.getters.getLmsSuperadminCustomerService('SSO')
    },
    customerHasServices () {
      return this.$store.getters.getLmsSuperadminCustomerServices
    },
    customerId () {
      return this.$store.getters.getLmsSuperadminCustomerId
    },
    customerTo: function () {
      return { name: 'lms-superadmin-customer-edit-services', params: { id: this.customerId } }
    }
  },
  methods: {
    allowRedirectBeforeRouteLeave: function () {
      this.$eventBus.$emit('customer-service-submit')
    },
    //
    subscriptionStopEdit: function () {
      const customerId = String(this.customerId)
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({ name: 'lms-superadmin-customer-edit-services', params: { id: customerId } })
    },
    handleAddSubscription () {
      if (this.serviceKey === 'SSO') {
        this.redirectToAddSSOService()
      } else {
        this.addSubscriptionTableItem()
      }
    },
    addSubscriptionTableItem () {
      this.$refs.servicetable.setAddSubscription(true)
    },
    redirectToAddSSOService () {
      this.$router.push({ name: 'lms-superadmin-customer-service-sso-add', params: { customerId: this.customerId } })
    }
  }
}
</script>

<style lang="scss">
    @import "~@/assets/scss/components/lms/superadmin/customers/_lmssuperadmincustomershowservice.scss";
</style>
